import NormalBtn from './NormalBtn';

function App(props) {

  var logInState = props.logInState;
  var logOut = props.logOut;
  var addToExtraScreen = props.addToExtraScreen;

  //change to log out;
  if (logInState){
    return <NormalBtn title='Log Out' onClick={logOut} icon='fe:logout' iconText='Log Out'/>
  }else{
    function clickLogIn(e){
      addToExtraScreen({t:'signIn'});
    }

    return <NormalBtn title='Sign In' onClick={clickLogIn} icon='fe:login' />
  }

}

export default App;
